const initialState = {
  data: [], // ✅ reemplaza allData
  total: 0,
  eventosTarea: [],
};

const clientesFibralink = (state = initialState, action) => {
  switch (action.type) {
    // 🔄 Carga de clientes FibraLink (listado o búsqueda)
    case 'GET_CLIENTES_FIBRALINK':
      return {
        ...state,
        data: Array.isArray(action.data) ? action.data : [],
        total: typeof action.total === 'number' ? action.total : 0,
      };

    // 📌 Carga de eventos de tarea por login
    case 'SET_EVENTOS_TAREA':
      return {
        ...state,
        eventosTarea: Array.isArray(action.data) ? action.data : [],
      };

    default:
      return state;
  }
};

export default clientesFibralink;
